import { DictionaryContext } from '../../../../providers'
import {
    ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS,
    resolveIconButtonAriaLabel,
} from '../../../../constants/iconButtonAriaLabelMessageKeys'
import { ReactNode, useContext, useEffect, useRef, useState } from 'react'

export const useTableRowExpandAnnouncement = (
    collapsedContent: ReactNode | undefined,
    isCollapsed: boolean,
): string => {
    const [expandAnnouncement, setExpandAnnouncement] = useState<string>('')
    const previousIsCollapsedRef = useRef<boolean | null>(null)
    const dictionary = useContext(DictionaryContext)

    useEffect(() => {
        if (!collapsedContent) {
            previousIsCollapsedRef.current = isCollapsed
            return
        }

        if (isCollapsed) {
            setExpandAnnouncement('')
            previousIsCollapsedRef.current = isCollapsed
            return
        }

        const wasCollapsed = previousIsCollapsedRef.current
        if (wasCollapsed === true) {
            setExpandAnnouncement('')
            const frameId = requestAnimationFrame(() => {
                // Polite status is deferred one frame so the live region clears first; some screen readers
                // coalesce or skip an update when the same text is set again in the same turn.
                setExpandAnnouncement(
                    resolveIconButtonAriaLabel(
                        dictionary,
                        ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS.TABLE_ROW_DETAILS_EXPANDED,
                    ),
                )
            })
            previousIsCollapsedRef.current = isCollapsed
            return () => cancelAnimationFrame(frameId)
        }

        previousIsCollapsedRef.current = isCollapsed
        return undefined
    }, [collapsedContent, isCollapsed])

    return expandAnnouncement
}
